var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb-input mt-0"},[_c('div',{staticClass:"icon-wrapper"}),_c('div',{staticClass:"input-wrapper"},[_c('span',{staticClass:"label mb-3"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.title)))]),_c('br'),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }